import { BigNumber } from "@ethersproject/bignumber";
import { VaultList } from "../constants/constants";
export var defaultLiquidityMiningPoolData = {
    responses: Object.fromEntries(VaultList.map(function (vault) { return [
        vault,
        {
            currentStake: BigNumber.from(0),
            poolSize: BigNumber.from(0),
            poolRewardForDuration: BigNumber.from(0),
            claimHistory: [],
            claimableRbn: BigNumber.from(0),
            unstakedBalance: BigNumber.from(0),
        },
    ]; })),
    loading: true,
};
export var defaultLiquidityGaugeV5PoolData = {
    responses: {},
    loading: true,
};
export var defaultStakingSubgraphData = { lm: {} };
export var defaultStakingAccountsData = { lm: {} };
//# sourceMappingURL=staking.js.map